import React, { useEffect, useState } from "react";
import "./systemSettingMenu.scss";

import { CheckableButton } from "components/CheckableButton/CheckableButton";
import { Price } from "components/Price/Price";
import { SelectBox } from "components/Select/Select";
import { Textbox } from "components/Textbox/Textbox";
import { Time } from "components/Time/Time";
import { SelectBoxHandle } from "./SelectBoxHandle";

import DatePicker from "components/DatePicker/DatePicker";
import { ProcessDictionary } from "pages/OfficeAutomation/Settings/ProcessSetting/components/ProcessDictionary/ProcessDictinary";
import { PropertyType } from "types/enum";

import { CheckBoxList } from "components/CheckboxList/CheckBoxList";
import { DictionarySelectBox } from "components/DictionaryTypeSelect/DictionaryTypeSelect";
import { INVENTORYANDSALES_URL } from "utils/constants";
import { ENDPOINTSINVENTORYANDSALES } from "utils/endpoints";
import { WarehouseDictionary } from "pages/InventoryAndSales/Sales/SalesInvoice/components/WarehouseDictionary/WarehouseDictionary";
import { CustomerDictionary } from "pages/InventoryAndSales/Sales/SalesInvoice/components/CustomerDictionary/CustomerDictionary";
import { FileInput } from "components/FileInput/FileInput";

export function SystemSettingForm({
  cards,
  setFromDate,
  userChanges,
  setUserChanges,
    setSelectedImage,
  selectedImage
}) {
  const [selectedSelectBox, setSelectedSelectBox] = useState<any>({});
  const [customer, setCustomer] = useState<any>();

    const [dataChange, setDataChange] = useState<boolean>(false);


  const changeHandlePic = (e: any,systemKey) => {
    if (e.target.files && e.target.files.length > 0) {
      const imageData = {
        Url: URL.createObjectURL([...e.target.files][0]),
        File: [...e.target.files][0],
      };
      setSelectedImage({...selectedImage,[systemKey]:imageData});
      setDataChange(true);
    }
  };

  useEffect(() => {
    let findItem = cards.find(
      (item) => item.SystemKey == "SystemSetting_EcommercePriceListPolicy"
    );

    if (findItem) {
      setSelectedSelectBox({
        ...selectedSelectBox,
        SystemSetting_EcommercePriceListPolicy: findItem?.SelectedValue,
      });
    } else {
      setSelectedSelectBox({
        ...selectedSelectBox,
        SystemSetting_EcommercePriceListPolicy: "0",
      });
    }
  }, [cards]);

  return (
    <div>
      <div className="row align-items-center ">
        {/* specify number of card */}
        {cards.map((item, index) => {
          return (
            <React.Fragment key={index}>
              {item.PropertyType == PropertyType.Text &&
                item.Values != "ProcessComponent" && (
                  <div className="col-sm-6 col-md-4">
                    <Textbox
                      textboxName={item.SystemKey}
                      textboxType={"text"}
                      labelText={item.Title}
                      Change={(e) => setUserChanges({ ...userChanges, ...e })}
                      defaultValue={
                        item.SelectedValue
                          ? item.SelectedValue
                          : userChanges[item.SystemKey]
                      }
                      mode={item?.ReadOnly?'view':'create'}

                    />
                  </div>
                )}
                     {item.PropertyType == PropertyType.TextArea &&
                item.Values != "ProcessComponent" && (
                  <div className="col-12">
                    <Textbox
                      textboxName={item.SystemKey}
                      textboxType={"textarea"}
                      labelText={item.Title}
                      Change={(e) => setUserChanges({ ...userChanges, ...e })}
                      defaultValue={
                        item.SelectedValue
                          ? item.SelectedValue
                          : userChanges[item.SystemKey]
                      }
                      mode={item?.ReadOnly?'view':'create'}

                    />
                  </div>
                )}
              {item.PropertyType == PropertyType.Number && (
                <div className="col-sm-6 col-md-4">
                  <Textbox
                    textboxName={item.SystemKey}
                    textboxType={"number"}
                    labelText={item.Title}
                    Change={(e) => setUserChanges({ ...userChanges, ...e })}
                    defaultValue={
                      item.SelectedValue
                        ? item.SelectedValue
                        : userChanges[item.SystemKey]
                    }
                    mode={item?.ReadOnly?'view':'create'}
                  />
                </div>
              )}
              {item.PropertyType == PropertyType.List && (
                <div className="col-sm-6 col-md-4 ">
                  <SelectBoxHandle
                    selectedSelectBox={selectedSelectBox}
                    setSelectedSelectBox={() => {}}
                    options={item?.Values?.split(",")}
                    userChanges={userChanges}
                    setUserChanges={setUserChanges}
                    item={item}
                  >
                    <SelectBox
                      onChange={(e) => {
                        setSelectedSelectBox({
                          ...selectedSelectBox,
                          [item.SystemKey]: e.target.value,
                        });
                      }}
                      lable={item.Title}
                      selectType="select"
                      value={
                        item.SelectedValue
                          ? item?.Values.split(",").find(
                              (listItem, index) => index == item.SelectedValue
                            )
                          : "0"
                      }
                      options={item?.Values?.split(",")}
                      val={item?.Values?.split(",")}
                      name={item.SystemKey}
                      mode={item?.ReadOnly?'view':'create'}
                    ></SelectBox>
                  </SelectBoxHandle>
                </div>
              )}
              {item.PropertyType == PropertyType.CheckBox && (
                <div className="my-2">
                  <CheckableButton
                    Change={(e) => {
                      setUserChanges({ ...userChanges, ...e });
                    }}
                    defaultChecked={
                      item.SelectedValue === "true" ? true : false
                    }
                    defaultValue={item.SelectedValue === "true" ? true : false}
                    labelText={item.Title}
                    inputName={item.SystemKey}
                    type="checkbox"
                    mode={item?.ReadOnly?'view':'create'}
                  />
                </div>
              )}
              {item.PropertyType == PropertyType.Date && (
                <div className="col-sm-6 col-md-4 ">
                  <DatePicker
                    Change={(e) => {
                      setUserChanges({ ...userChanges, ...e });
                    }}
                    lable={item.Title}
                    setIsoTime={(isoTime: string) => {
                      setFromDate(isoTime);
                    }}
                    val={item.SelectedValue ? item.SelectedValue : null}
                    name={item.SystemKey}
                    onOpenPickNewDate={true}
                    mode={item?.ReadOnly?'view':'create'}
                  />
                </div>
              )}
              {item.PropertyType == PropertyType.Time && (
                <div className="col-sm-6 col-md-4 ">
                  <Time
                    Change={(e) => {
                      setUserChanges({ ...userChanges, ...e });
                    }}
                    name={item.SystemKey}
                    IdString={item.SystemKey}
                    defaultValue={item?.SelectedValue}
                    label={item.Title}
                    mode={item?.ReadOnly?'view':'create'}
                  />
                </div>
              )}
              {item.PropertyType == PropertyType.Price && (
                <div className="col-sm-6 col-md-4 ">
                  <Price
                    name={item.SystemKey}
                    defaultValue={item.SelectedValue ? item.SelectedValue : 0}
                    label={item.Title}
                    onChange={(e) =>
                      setUserChanges({
                        ...userChanges,
                        [item.SystemKey]: e.target.value,
                      })
                    }
                    mode={item?.ReadOnly?'view':'create'}
                  />
                </div>
              )}
              {item.PropertyType == PropertyType.CheckBoxList && (
                <div className="">
                  <CheckBoxList
                    textboxName={item.SystemKey}
                    title={item.Title}
                    items={JSON.parse(item.SelectedValue)}
                    onChange={(e) => {
                      console.log({ e });
                    }}
                   mode={item?.ReadOnly?'view':'create'}
                  />
                </div>
              )}
                {item.PropertyType == PropertyType.Picture &&
                                          (
                              <div className="col-sm-6 col-md-4">
                                
                                          <FileInput

                                          maxSize={25600000}
                                          defultFileName="profilePicture.jpg"
                                          hideSrc={false}
                                          lable={item.SystemKey}
                                          name={item.SystemKey}
                                          onChange={(e)=>changeHandlePic(e,item.SystemKey)}
                                          multiple={false}
                                          accept="image/*"
                                          src={
                                            selectedImage?.[item.SystemKey]
                                               ? selectedImage?.[item.SystemKey]?.Url
                                             :  item?.SelectedValue
                                          }
                                          
                                        />
                                              </div>
                                          )
                                          
                                          }
              {(item.PropertyType == PropertyType.Dictanory ||
                item.Values === "ProcessComponent") &&
                (item.Values === "WarehouseComponent" ? (
                  <div className="col-sm-6 col-md-4">
                    <WarehouseDictionary
                      name={item.SystemKey}
                      label={item.Title}
                      value={
                        item?.SelectedValue ? item?.SelectedValue : undefined
                      }
                      hasWarehouseDetails={false}
                      mode={item?.ReadOnly?'view':'create'}
                    />
                  </div>
                ) : item.Values === "PriceListComponent" ? (
                  // (selectedSelectBox.SystemSetting_EcommercePriceListPolicy&&item.SystemKey=="SystemSetting_EcommercePriceList"&&selectedSelectBox.SystemSetting_EcommercePriceListPolicy== "لیست قیمت فروشگاه")

                  <div className="col-sm-6 col-md-4">
                    {selectedSelectBox.SystemSetting_EcommercePriceListPolicy &&
                    item.SystemKey == "SystemSetting_EcommercePriceList" &&
                    (selectedSelectBox.SystemSetting_EcommercePriceListPolicy ==
                      "0" ||
                      selectedSelectBox.SystemSetting_EcommercePriceListPolicy ==
                        "الگوی قیمت فروشگاه") ? (
                      <DictionarySelectBox
                        label={item.Title}
                        name={item.SystemKey}
                        baseUrl={INVENTORYANDSALES_URL}
                        endPoint={
                          ENDPOINTSINVENTORYANDSALES.Sales.BaseInformationApi
                            .PriceListApis.ecommercePriceListlistDictionary
                        }
                        value={
                          item?.SelectedValue ? item?.SelectedValue : undefined
                        }
                        mode={item?.ReadOnly?'view':'create'}
                      />
                    ) : (
                      <></>
                    )}
                  </div>
                ) : item.Values === "CustomerDictionaryComponent" ? (
                  <div className="col-sm-6 col-md-4">
                    <CustomerDictionary
                      name={item.SystemKey}
                      label={item.Title}
                      value={item?.SelectedValue}
                      returnObj={true}
                      onChange={(e) => {
                        setCustomer(e);
                      }}
                      // disabled={mode!=='create'?true:false}
                      mode={item?.ReadOnly?'view':'create'}
                    />
                  </div>
                ) : (
                  <div className="col-sm-6 col-md-4">
                    <ProcessDictionary
                      name={item.SystemKey}
                      label={item.Title}
                      value={
                        item?.SelectedValue ? item?.SelectedValue : undefined
                      }
                      mode={item?.ReadOnly?'view':'create'}
                    />
                  </div>
                ))}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
}
